// extracted by mini-css-extract-plugin
export default {"projectContainer":"Projects_projectContainer__qsDiP","bodyContainer":"Projects_bodyContainer__XLrF5"};